import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs/Observable";
import 'rxjs/Rx';
import 'rxjs/add/operator/catch';


import * as _ from 'lodash';
import { EndpointFactory } from "./endpoint-factory.service";
import { HttpClient } from "@angular/common/http";
import { ConfigurationService } from "./configuration.service";

@Injectable()
export class CaseManagementService extends EndpointFactory {

    private _baseURl = "";

    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
        super(http, configurations, injector);
    }

    getCasesList(memberId: string): Observable<any> {
        return this.http.get(this._baseURl + `api/caseManagement/get-cases/${memberId}`, this.getRequestHeaders())
            .catch(err => this.handleError(err, null));
    }

    getProviderSepcialtiesList() {
        return this.http
            .get(this._baseURl + `api/providerSpecialties/get-provider-specialties-list`, this.getRequestHeaders())
            .catch( err => this.handleError(err, null) )
    }

    getCaseByCaseManager(caseManagerId : string): Observable<any> {
        return this.http
            .get(this._baseURl + `api/caseManagement/get-case-by-manager/${caseManagerId}`, this.getRequestHeaders())
            .catch(er => this.handleError(er, null))
    }

    getLastNotes(arr): Observable<any> {
        return this.http
            .post(this._baseURl + `api/caseManagement/get-list-notes-lastest`, arr, this.getRequestHeaders())
            .catch(err => this.handleError(err, null))
    }


    getStats() {
        return this.http
            .get(this._baseURl + `/api/caseManagement/get-stats`, this.getRequestHeaders())
            .catch(err => this.handleError(err, null))
    }

    getAllCaseDashboard() {
        return this.http
            .get(this._baseURl + `/api/caseManagement/get-all-case-dashboard`, this.getRequestHeaders())
            .catch(err => this.handleError(err, null));
    }

    getAllOpenCaseDashboard() {
        return this.http
            .get(this._baseURl + `/api/caseManagement/get-all-open-case-dashboard`, this.getRequestHeaders())
            .catch(err => this.handleError(err, null));
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/case-management.service.ts